
import React from "react";
import AboutHero from "@/components/about/AboutHero";
import AboutIntro from "@/components/about/AboutIntro";
import BiographySection from "@/components/about/BiographySection";
import BackgroundSection from "@/components/about/BackgroundSection";
import AboutCTA from "@/components/about/AboutCTA";

const About = () => {
  return (
    <div className="fade-in">
      <AboutHero />
      
      <section className="section-padding bg-white">
        <div className="container-custom">
          <AboutIntro />
          <BiographySection />
          <BackgroundSection />
        </div>
      </section>
      
      <AboutCTA />
    </div>
  );
};

export default About;
